var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-cap"},[_c(_vm.component,{tag:"component",attrs:{"surveillance":_vm.surveillance,"year":_vm.year,"module":_vm.module,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }